import { ReactNode, useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { authStore } from '@/stores/AuthStore'

interface ProtectedRouteProps {
  children: ReactNode
}

const ProtectedRoute = observer(({ children }: ProtectedRouteProps) => {
  const location = useLocation()

  useEffect(() => {
    // Try to fetch current user if token exists
    const token = localStorage.getItem('access_token')
    if (token && !authStore.user && !authStore.isLoading) {
      authStore.fetchCurrentUser().catch(() => {
        // Failed to fetch user, will redirect to login
      })
    }
  }, [])

  // Playwright test/recording bypass — skip the auth gate when the recorder
  // seeds `playwright-bypass-auth=true` in localStorage. Harmless in prod
  // (no runtime sets that key outside the scene harness).
  const bypass = typeof window !== 'undefined'
    && window.localStorage?.getItem('playwright-bypass-auth') === 'true'

  if (authStore.isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!authStore.isAuthenticated && !bypass) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
})

export default ProtectedRoute
